import { useState, useCallback, type ReactNode } from 'react'
import { isCypressWindow } from '@retailer-platform/shared-common'
import { type IPP_SUPPORTED_LOCALE, IPP_DEFAULT_LOCALE } from './intl.types'
import { I18nContext } from './I18nContext'
import { getStoredLocaleWithFallback, LOCALE_STORAGE_KEY } from './intl.utils'
interface I18nProviderProps {
  children: ReactNode
  defaultLocale?: IPP_SUPPORTED_LOCALE
}

export const I18nProvider = ({
  children,
  defaultLocale = IPP_DEFAULT_LOCALE,
}: I18nProviderProps) => {
  const [locale, setLocaleState] = useState<IPP_SUPPORTED_LOCALE>(
    getStoredLocaleWithFallback(defaultLocale)
  )

  const setLocale = useCallback((newLocale: IPP_SUPPORTED_LOCALE) => {
    setLocaleState(newLocale)
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, newLocale)
    } catch (error) {
      console.warn('Failed to save locale to localStorage:', error)
    }

    if (!isCypressWindow()) {
      window.location.reload()
    }
  }, [])

  return <I18nContext.Provider value={{ locale, setLocale }}>{children}</I18nContext.Provider>
}
